// extracted by mini-css-extract-plugin
export default {"Panel":"MZvKUlwa","Primary":"Ltw8eLfC","Secondary":"w9qBluC7","TabbedPanel":"_9vTlMDm","TabbedContainer":"ZDqUjgC7"};